import { useQuery } from '@tanstack/react-query';
import { PodgladKaskady } from '@/components/PodgladKaskady';
import { ZmianaKlucza } from '@/components/ZmianaKlucza';
import { checkItemNumber, fetchItemRenameImpact, zmienNumerTowaru } from '@/lib/items-api';
import { useI18n } from '@/lib/i18n';

/**
 * ZMIANA NUMERU TOWARU — odmiana wspólnego okna zmiany klucza.
 *
 * ⚠️ Z PODGLĄDEM ZAKRESU, w odróżnieniu od pracownika i grupy pracowniczej. Tam każda tabela
 * kaskady ma dyskryminator, więc rusza się dokładnie to, co dotyczy tej osoby albo tej grupy.
 * Tutaj `Rationing.ITEMKEY` idzie BEZ filtru po `ITEMTYPE` (decyzja D1 — parytet ze
 * zdekompilowaną kaskadą SPS), więc zmiana numeru towaru `X` przepisze też regułę limitu GRUPY
 * o kodzie `X`. Na parytet zgodziliśmy się pod warunkiem, że to widać przed kliknięciem.
 */
export function ZmianaNumeruTowaru({
  towarId,
  islandId,
  obecnyNumer,
  nazwa,
  onClose,
  onSaved,
}: {
  towarId: string;
  islandId: string;
  obecnyNumer: string;
  nazwa: string;
  onClose: () => void;
  onSaved: () => void;
}) {
  const { t } = useI18n();
  const zakres = useQuery({
    queryKey: ['item', 'rename-impact', towarId, islandId],
    queryFn: () => fetchItemRenameImpact(towarId, islandId),
  });

  return (
    <ZmianaKlucza
      tytul={t('itm.numberChangeTitle')}
      podpis={`${nazwa} · ${obecnyNumer}`}
      wstep={t('itm.numberChangeIntro')}
      ostrzezenie={t('itm.numberChangeWarn')}
      etykietaPola={t('itm.numberChangeNew')}
      obecny={obecnyNumer}
      /** `Items.ITEMNUMBER` — 32 znaki. */
      limit={32}
      podglad={zakres.data ? <PodgladKaskady targets={zakres.data.targets} /> : null}
      sprawdz={(v) => checkItemNumber(islandId, v)}
      zapisz={async (nowy) => {
        const r = await zmienNumerTowaru(towarId, { groupId: islandId, nowyNumer: nowy });
        return t('itm.numberChanged').replace('{stary}', r.stary).replace('{nowy}', r.nowy);
      }}
      onClose={onClose}
      onSaved={onSaved}
    />
  );
}
